import { render, staticRenderFns } from "./CallDetailsPage.vue?vue&type=template&id=6d284792&scoped=true"
import script from "./CallDetailsPage.vue?vue&type=script&lang=js"
export * from "./CallDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./CallDetailsPage.vue?vue&type=style&index=0&id=6d284792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d284792",
  null
  
)

export default component.exports